import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";

const x6Api = `${baseRoutes.x6}/api/v1/machine`;

export async function deleteX6Machine(id: string): Promise<void> {
	await packNetAxios.delete(`${x6Api}/${id}`);
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.x6}/api/v1/version`);
	return response.data;
}
